import { render, staticRenderFns } from "./edit-pwd-drawer.vue?vue&type=template&id=4fa0c603&scoped=true&"
import script from "./edit-pwd-drawer.vue?vue&type=script&lang=js&"
export * from "./edit-pwd-drawer.vue?vue&type=script&lang=js&"
import style0 from "./edit-pwd-drawer.vue?vue&type=style&index=0&id=4fa0c603&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa0c603",
  null
  
)

export default component.exports